import React from 'react';
import { Col, Flex, Grid, Link, Row, Spacer, Text, useTheme } from 'vcc-ui';

export const MarketingFluff = () => {
  const theme = useTheme();
  return (
    <Flex extend={{ background: theme.color.background.primary }}>
      <Spacer size={8} />
      <Grid>
        <Row align="center">
          <Col>
            <Flex
              extend={{ [theme.breakpoints.fromM]: { textAlign: 'center' } }}
            >
              <Text variant="cook">Empowering teams to build for the web</Text>
              <Spacer size={4} />
            </Flex>
          </Col>
        </Row>
        <Row align="center">
          <Col size={6}>
            <Flex
              extend={{ [theme.breakpoints.fromM]: { textAlign: 'center' } }}
            >
              <Text variant="hillary">
                With VCC UI you have the tools to deliver high-quality brand
                consistent web applications without sacrificing time-to-market.
              </Text>
            </Flex>
          </Col>
        </Row>
        <Spacer size={10} />
        <Row>
          <Col size={4}>
            <Flex extend={{ alignItems: 'flex-start' }}>
              <Text variant="hillary" subStyle="emphasis">
                Align With Global Brand
              </Text>
              <Spacer size={2} />
              <Text>
                VCC UI keeps your product UI/UX in line with company branding
                and guidelines by utilizing the Volvo Cars Design Language
                System. Includes brand approved colors, typography, layout,
                icons and more.
              </Text>
              <Spacer size={3} />
              <Link arrow="right" href="/docs">
                Learn More
              </Link>
              <Spacer size={6} />
            </Flex>
          </Col>
          <Col size={4}>
            <Text variant="hillary" subStyle="emphasis">
              Reduce Time-To-Market
            </Text>
            <Spacer size={2} />
            <Text>
              Includes Starter kits and real world examples for the most popular
              Node.js and React frameworks like Create-React-App and Next.js. Go
              from idea to delivery in no time.
            </Text>
            <Spacer size={3} />
            <Link
              arrow="right"
              href="https://github.com/volvo-cars/vcc-ui/tree/master/examples"
            >
              View Examples
            </Link>
            <Spacer size={6} />
          </Col>
          <Col size={4}>
            <Text variant="hillary" subStyle="emphasis">
              Tried & Tested UI Components
            </Text>
            <Spacer size={2} />
            <Text>
              Mobile first, fully responsive and renders in server-side, browser
              & react-native environments Built with accessibility, performance
              and SEO best practices in mind. Full i18n support, including RTL
              languages.
            </Text>
            <Spacer size={3} />
            <Link arrow="right" href="https://vcc-ui-storybook.vercel.app/">
              View Storybook
            </Link>
            <Spacer size={6} />
          </Col>
        </Row>
      </Grid>
      <Spacer size={4} />
    </Flex>
  );
};
